<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-24 13:38:04
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-25 15:39:50
-->
<template>
	<el-form :model="formData" label-width="170px" ref="form" :rules="rules">
		<el-form-item label="商品限制" prop="cos_limit_type">
			<el-radio-group v-model="formData['cos_limit_type']" @change="resetForm">
				<el-radio label="1" style="margin-right: 0;"><span class="label-width">无限制</span></el-radio>
				<el-radio label="2"><span class="label-width">仅限双佣金商品</span></el-radio>
				<el-radio label="3"><span class="label-width">仅限固定佣金商品</span></el-radio>
			</el-radio-group>
		</el-form-item>
		<el-form-item label="固定/日常佣金率≥" prop="commission_rate">
			<el-input
				v-model="formData['commission_rate']"
				placeholder="请输入1-50的数字"
				style="width: 400px"
				@input="val => change('commission_rate', val)"
			>
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="固定/日常服务费率≥" prop="service_rate">
			<el-input v-model="formData['service_rate']" placeholder="请输入0-40的数字" style="width: 400px" @input="val => change('service_rate', val)">
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="投放期佣金率≥" prop="ad_commission_rate" v-if="formData.cos_limit_type !== '3'">
			<el-input
				v-model="formData['ad_commission_rate']"
				placeholder="请输入1-50的数字"
				style="width: 400px"
				@input="val => change('ad_commission_rate', val)"
			>
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="投放期服务费率≥" prop="ad_service_rate" v-if="formData.cos_limit_type !== '3'">
			<el-input v-model="formData['ad_service_rate']" placeholder="请输入0-40的数字" style="width: 400px" @input="val => change('ad_service_rate', val)">
				<template slot="append">%</template>
			</el-input>
		</el-form-item>
		<el-form-item label="预估单品成交" prop="estimated_single_sale">
			<el-input
				v-model="formData['estimated_single_sale']"
				placeholder="请输入单品预估成交金额"
				style="width: 400px"
				@input="val => change('estimated_single_sale', val)"
			>
				<template slot="prepend">¥</template>
			</el-input>
		</el-form-item>
	</el-form>
</template>
<script>
import { isServiceRate, isValidNoZeroPriceReg } from '@/utils/reg';
import mixin from '../../mixin';
export default {
	name: 'CoopPriceForm',
	mixins: [mixin],
	data() {
		const _reg = /^(([1-9])|([1-4]\d)|50)$/;
		const validator1 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('佣金率不可为空'));
			} else if (!_reg.test(value)) {
				callback(new Error('佣金率错误，请输入1-50的数字'));
			} else {
				callback();
			}
		};
		const validator2 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('服务费率不可为空'));
			} else if (!isServiceRate.test(value)) {
				callback(new Error('服务费率只能为0-40的数字'));
			} else {
				callback();
			}
		};
		const validator3 = (rule, value, callback) => {
			if (value === '') {
				callback(new Error('单品预估成交金额不可为空'));
			} else if (!isValidNoZeroPriceReg.test(value) && +value !== 0) {
				callback(new Error('单品预估成交金额只能为数字'));
			} else {
				callback();
			}
		};
		return {
			formData: {
				cos_limit_type: '1',
				commission_rate: '',
				service_rate: '',
				estimated_single_sale: '',
				ad_commission_rate: '',
				ad_service_rate: '',
			},
			rules: {
				cos_limit_type: [{ required: true, message: '请选择商品限制' }],
				commission_rate: [{ required: true, validator: validator1, triggle: 'blur' }],
				service_rate: [{ required: true, validator: validator2, triggle: 'blur' }],
				estimated_single_sale: [{ required: true, validator: validator3, triggle: 'blur' }],
				ad_commission_rate: [{ required: true, validator: validator1, triggle: 'blur' }],
				ad_service_rate: [{ required: true, validator: validator2, triggle: 'blur' }],
			},
		};
	},
	methods: {
		validate() {
			return new Promise((resolve, reject) => {
				this.$refs.form.validate(valid => {
					if (valid) {
						resolve(this.formData);
					} else {
						reject(valid);
						return false;
					}
				});
			});
		},
		resetForm(value) {
			this.$refs.form.resetFields();
			this.formData.commission_rate = '';
			this.formData.service_rate = '';
			this.formData.ad_commission_rate = '';
			this.formData.ad_service_rate = '';
			this.formData.cos_limit_type = value;
			this.formData.estimated_single_sale = '';
			this.change('cos_limit_type', value)
			this.change('commission_rate', '');
			this.change('service_rate', '');
			this.change('ad_commission_rate', '');
			this.change('ad_service_rate', '');
			this.change('estimated_single_sale', '');
		},
		isFormModified() {
			return this.isModified;
		},
	},
};
</script>
<style lang="less" scoped>
.label-width{
	display: inline-block;
	width: 80px;
}
/deep/ .el-input-group__append,
/deep/ .el-input-group__prepend {
	border: 1px solid #e3e3e3;
}
/deep/ .el-input-group__append {
	border-left: none;
}
/deep/ .el-input-group__prepend {
	border-right: none;
}
</style>